(() => {
  /* ── Elements ── */
  const drawer = document.getElementById('pdp-drawer');
  const backdrop = document.getElementById('pdp-drawer-backdrop');
  const body = document.getElementById('pdp-drawer-body');
  if (!drawer || !backdrop || !body) return;

  const els = {
    title: body.querySelector('[data-drawer-title]'),
    image: body.querySelector('[data-drawer-image]'),
    imageEl: body.querySelector('[data-drawer-image-el]'),
    imageSkeleton: body.querySelector('[data-drawer-image-skeleton]'),
    sku: body.querySelector('[data-drawer-sku]'),
    price: body.querySelector('[data-drawer-price]'),
    availability: body.querySelector('[data-drawer-availability]'),
    description: body.querySelector('[data-drawer-description]'),
    specs: body.querySelector('[data-drawer-specs]'),
    link: body.querySelector('[data-drawer-link]'),
  };

  const specsSkeletonHtml = els.specs?.innerHTML || '';

  /* ── Helpers ── */
  const { MONEY_FORMAT = '', CURRENCY = '' } = window;

  const formatMoney = (cents) =>
    Shopify.formatMoney
      ? Shopify.formatMoney(cents, MONEY_FORMAT)
      : (cents / 100).toLocaleString(undefined, { style: 'currency', currency: CURRENCY });

  const resizeImageUrl = (src) =>
    typeof src === 'string' ? src : src?.src || '';

  const getImageSrc = (variant, product) => {
    const raw = variant.featured_image || product.images[0];
    const src = resizeImageUrl(raw);
    return src ? src.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_600x.$1') : '';
  };

  /* ── Specs ── */
  const CELL = 'border border-gray-300 px-3 py-2';
  const TABLE = 'w-full mt-2 border-collapse border border-gray-300';
  const specsCache = {};

  const renderSpecsGroup = (group) => {
    const rows = group.rows.filter((r) =>
      r.value !== '' && r.value != null && !(Array.isArray(r.value) && !r.value.length)
    );
    if (!rows.length) return '';

    const rowsHtml = rows.map(({ label, value, type }) => {
      const cell = type === 'list'
        ? `<ul class="list-disc list-inside space-y-0.5">${value.map((i) => `<li>${i}</li>`).join('')}</ul>`
        : String(value);
      return `<tr>
        <td class="${CELL} font-medium align-top">${label}</td>
        <td class="${CELL}">${cell}</td>
      </tr>`;
    }).join('');

    return `<div class="text-sm text-gray-600 mb-6">
      <strong>${group.label}</strong>
      <table class="${TABLE} table-fixed">
        <colgroup><col class="w-2/5"><col class="w-3/5"></colgroup>
        <tbody>${rowsHtml}</tbody>
      </table>
    </div>`;
  };

  const fetchSpecs = async (url) => {
    if (specsCache[url] !== undefined) return specsCache[url];
    try {
      const res = await fetch(url);
      if (!res.ok) {
        specsCache[url] = null;
        return null;
      }
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[id^="VariantSpecsJson-"]');
      if (el) {
        specsCache[url] = JSON.parse(el.textContent);
        return specsCache[url];
      }
    } catch (err) {
      console.error('Error fetching product specs:', err);
    }
    specsCache[url] = null;
    return null;
  };

  const renderSpecs = async (url, variantId) => {
    els.specs.innerHTML = specsSkeletonHtml;
    const specsMap = await fetchSpecs(url);
    const groups = specsMap?.[String(variantId)];
    els.specs.innerHTML = groups?.length
      ? `<div class="border-t border-gray-200 pt-4">${groups.map(renderSpecsGroup).join('')}</div>`
      : '';
  };

  /* ── Open / Close ── */
  const open = async (product, sku) => {
    requestAnimationFrame(() => {
      drawer.classList.remove('translate-x-full');
      backdrop.classList.remove('opacity-0', 'pointer-events-none');
      document.body.style.overflow = 'hidden';
    });

    const variant = product.variants.find((v) => v.sku === sku) || product.variants[0];
    const imageSrc = getImageSrc(variant, product);
    const url = `${Shopify.routes.root}products/${product.handle}`;

    els.title.textContent = product.title;

    if (imageSrc) {
      els.imageSkeleton.classList.remove('hidden');
      els.imageEl.classList.add('hidden');
      els.imageEl.onload = () => {
        els.imageSkeleton.classList.add('hidden');
        els.imageEl.classList.remove('hidden');
      };
      els.imageEl.src = imageSrc;
      els.imageEl.alt = product.title;
      els.image.classList.remove('hidden');
    } else {
      els.imageEl.onload = null;
      els.imageEl.src = '';
      els.image.classList.add('hidden');
    }

    els.sku.textContent = variant.sku;
    els.price.textContent = formatMoney(variant.price);
    els.availability.textContent = variant.available ? 'In Stock' : 'Out of Stock';
    els.availability.classList.toggle('text-green-600', variant.available);
    els.availability.classList.toggle('text-red-600', !variant.available);

    if (product.description) {
      els.description.innerHTML = product.description;
      els.description.classList.remove('hidden');
    } else {
      els.description.innerHTML = '';
      els.description.classList.add('hidden');
    }

    els.link.href = url;

    body.classList.remove('hidden');

    renderSpecs(url, variant.id);
  };

  const close = () => {
    drawer.classList.add('translate-x-full');
    backdrop.classList.add('opacity-0', 'pointer-events-none');
    document.body.style.overflow = '';
  };

  /* ── Event listeners ── */
  backdrop.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) { close(); return; }

    const link = e.target.closest('.sku-cell a');
    if (!link) return;

    const url = link.getAttribute('href');
    const product = (window.__pdpDrawer?.productDataCache || {})[url];
    if (!product) return;

    e.preventDefault();
    open(product, link.closest('.component-row')?.dataset.sku);
  });
})();
